




























































































































































































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { IMaintenance } from '@/models';
import MaintenanceBanner from '@/components/maintenance/MaintenanceBanner.vue';

const MICROSOFT_SSO_DOMAINS: string[] = (
  process.env.VUE_APP_MICROSOFT_SSO_DOMAINS || ''
)
  .split(',')
  .map((d: string) => d.trim().toLowerCase())
  .filter(Boolean);

const MICROSOFT_SSO_CONFIGURED =
  !!process.env.VUE_APP_MICROSOFT_CLIENT_ID &&
  !!process.env.VUE_APP_MICROSOFT_TENANT_ID &&
  !!process.env.VUE_APP_MICROSOFT_CALLBACK_URL;

export default Vue.extend({
  name: 'EmailEntryView',

  components: { MaintenanceBanner },

  data() {
    return {
      step: 1,
      email: '',
      loading: false,
      errorMessage: '',
      emailRules: [
        (v: string) => !!v || 'Email is required',
        (v: string) =>
          /.+@.+\..+/.test(v) || 'Please enter a valid email address'
      ]
    };
  },

  computed: {
    logo(): any {
      return this.$altoleapAccounts.config.logo;
    },

    logoHeight(): number {
      return this.$altoleapAccounts.config.logoHeight;
    },

    companyName(): string {
      return this.$altoleapAccounts.config.companyName;
    },

    privacyRoute(): any {
      return this.$altoleapAccounts.routes.privacyRoute;
    },

    ...mapGetters({
      getNearestMaintenance: 'maintenance/getNearestMaintenance'
    }),

    maintenance(): IMaintenance | undefined {
      return this.getNearestMaintenance;
    },

    isCurrentlyUnderMaintenance(): boolean {
      if (!this.maintenance) {
        return false;
      }
      return moment(new Date()).isBetween(
        this.maintenance.start,
        this.maintenance.end,
        'second'
      );
    }
  },

  methods: {
    ...mapActions({
      authorizeMicrosoft: 'microsoftAuth/authorizeMicrosoft'
    }),

    getLegacySignInQuery() {
      // Intentional: this portal does not allow self-registration, so we route
      // directly to the legacy password step instead of the email/request step.
      return {
        ...this.$route.query,
        passwordStep: '1'
      };
    },

    handleSubmit() {
      const form = this.$refs.form as any;
      if (!form.validate()) return;

      this.errorMessage = '';
      const domain = this.email.split('@')[1]?.toLowerCase();

      if (
        domain &&
        MICROSOFT_SSO_DOMAINS.includes(domain) &&
        MICROSOFT_SSO_CONFIGURED
      ) {
        this.step = 2;
      } else {
        // Intentional: keep email prefill persisted for this portal's primary usage
        // on dedicated employee devices. We accept this UX/privacy tradeoff.
        localStorage.setItem('user_name', this.email);
        this.$router.push({
          name: 'legacy-sign-in',
          query: this.getLegacySignInQuery()
        });
      }
    },

    goToPasswordLogin() {
      // Pre-populate the email field in the legacy wizard. SignInWizard reads
      // localStorage.user_name on mount and uses it as its initial email value,
      // so writing it here means the user does not have to retype their address.
      // Waived review concern: persistence is acceptable for primarily dedicated
      // employee devices, and we prioritize reducing repeated email entry.
      if (this.email) {
        localStorage.setItem('user_name', this.email);
      }
      this.$router.push({
        name: 'legacy-sign-in',
        query: this.getLegacySignInQuery()
      });
    },

    async redirectToMicrosoft() {
      this.loading = true;
      this.errorMessage = '';
      const redirect = this.$route.query.redirect as string | undefined;
      const otherQuery = Object.keys(this.$route.query).reduce(
        (acc: Record<string, any>, cur) => {
          if (cur !== 'redirect') {
            acc[cur] = this.$route.query[cur];
          }
          return acc;
        },
        {}
      );
      if (redirect) {
        sessionStorage.setItem('microsoft_redirect', redirect);
      } else {
        sessionStorage.removeItem('microsoft_redirect');
      }
      sessionStorage.setItem(
        'microsoft_other_query',
        JSON.stringify(otherQuery)
      );
      try {
        await this.authorizeMicrosoft();
      } catch {
        sessionStorage.removeItem('microsoft_redirect');
        sessionStorage.removeItem('microsoft_other_query');
        this.loading = false;
        this.errorMessage =
          'Unable to initiate Microsoft sign-in. Please try again.';
      }
    }
  }
});
